import { Profile } from "./molecules/Profile";
import { MobilePropertyValue } from "./molecules/MobilePropertyValue";
import { MobileDownpayment } from "./molecules/MobileDownpayment";
import { MobileZip } from "./molecules/MobileZip";
import IconButton from "@mui/material/IconButton";
import { EditIcon } from "../../atoms/icons/edit";
import { AvailableLoanOptionsIcon } from "../../atoms/icons/available-loan-options";
import { MobileMainText } from "./molecules/MobileMainText";
import { ViewAs } from "./molecules/ViewAs";
import { SortBy } from "./molecules/SortBy";
import { MobileBottomBar } from "./molecules/MobileBottomBar";
import React from "react";
import { MobileLoanList } from "./molecules/MobileLoanList";

export const LoansMobileView = ({
  hideTopBar,
  isGrid,
  setGrid,
  isComparedIds,
  setComparedId,
  sorting,
  setSorting,
  sortedLoans,
  setIsComparisonView,
  comparedQuotes,
  setDetails,
  setShowSettingsModal,
  enteredData,
}) => {
  const { price, downPayment, zip } = enteredData;

  return (
    <div className="irq-mobile">
      {!hideTopBar && (
        <div className="top-stats-bar">
          <Profile />
          <MobilePropertyValue price={price} />
          <MobileDownpayment downpayment={downPayment} />
          <MobileZip zip={zip} />
          <div className="bold">...</div>
          <IconButton
            onClick={() => setShowSettingsModal(true)}
            aria-label="delete"
          >
            <EditIcon fill="white" width="24" height="24" />
          </IconButton>
        </div>
      )}

      <div className="irq-main-section-wrapper gap">
        <div className="irq-main-section-info-text">
          <div className="flex-row align-items-center">
            <AvailableLoanOptionsIcon className="margin-right" fill="white" />
            <div className="bold">Available Loan Options</div>
          </div>
          <MobileMainText />
          <div className="irq-middle-menu">
            <ViewAs isGrid={isGrid} setGrid={setGrid} />
            <SortBy sorting={sorting} setSorting={setSorting} />
          </div>

          <MobileLoanList
            sortedLoans={sortedLoans}
            isGrid={isGrid}
            setDetails={setDetails}
            isComparedIds={isComparedIds}
            setComparedId={setComparedId}
          />
        </div>
      </div>

      <MobileBottomBar
        quotes={comparedQuotes}
        isComparedIds={isComparedIds}
        setIsComparisonView={setIsComparisonView}
      />
    </div>
  );
};
